import {gql} from '@apollo/client'

export const LOGIN_MUTATION = gql`
    mutation login($email: String, $password: String!) {
        authentication(email: $email, password: $password) {
            user {
                id
                username
                email
                stripeCustomerId
                stripeSubscriptionId
                subscriptionStatus
            }
            subscribed
            paid
            token
            refreshToken
            expiresFromNow
            errors
        }
    }
  `